// Shared membership display calculations, reused from MyMembershipsPage.
export function hasCurrentMembershipPlan(items, planId, now = Date.now()) {
  if (!planId) return false;
  return (items || []).some((item) => {
    const row = item.membership || item;
    if ((row.planId || item.plan?.id) !== planId) return false;
    const status = membershipStatusValue(row.status);
    if (["pending_payment", "pending_activation", "past_due", "grace_period"].includes(status)) return true;
    if (!["active", "cancel_at_period_end"].includes(status)) return false;
    const end = row.currentPeriodEnd || row.endDate || row.expiresAt;
    const time = end?.toDate ? end.toDate().getTime() : end?.seconds ? end.seconds * 1000 : end ? new Date(end).getTime() : NaN;
    return !Number.isFinite(time) || time > now;
  });
}
export function membershipStatusValue(value) {
  const status = String(value || "active").trim().toLowerCase();
  if (["cancelled", "canceled", "cancelada", "cancelado"].includes(status)) return "cancelled";
  if (["expired", "expirada", "expirado", "vencida", "vencido"].includes(status)) return "expired";
  if (["paused", "pausada", "pausado"].includes(status)) return "paused";
  return status;
}
export function membershipStatusLabel(value) {
  return ({ active: "Activa", cancelled: "Cancelada", expired: "Vencida", paused: "Pausada", pending_payment: "Pendiente de pago", pending_activation: "Pendiente de activación", cancel_at_period_end: "Sin renovación automática", past_due: "Pago pendiente" })[membershipStatusValue(value)] || "Pendiente";
}
export function membershipBenefitType(membership = {}, plan = {}) {
  const raw = String(
    membership.benefitType ||
    membership.membershipType ||
    membership.membershipBenefitType ||
    membership.usageLimitType ||
    plan.benefitType ||
    plan.membershipType ||
    plan.usageLimitType ||
    ""
  ).trim().toLowerCase();

  if (membership.unlimitedUsage === true || membership.isUnlimited === true || plan.unlimitedUsage === true) return "unlimited";
  if (["unlimited", "ilimitado", "ilimitada", "uso_ilimitado", "uso ilimitado", "unlimited_usage"].includes(raw)) return "unlimited";
  if (["discount", "descuento", "discount_only", "solo_descuento", "solo descuento"].includes(raw)) return "discount";

  const included = Number(membership.includedCredits ?? plan.includedCredits ?? membership.creditsTotal ?? plan.credits ?? 0);
  const discount = Number(plan.discountPercent ?? membership.discountPercent ?? 0);
  if ((!Number.isFinite(included) || included <= 0) && Number.isFinite(discount) && discount > 0) return "discount";
  return "credits";
}


export function membershipCreditStats(membership = {}, plan = {}) {
  const benefitType = membershipBenefitType(membership, plan);
  const isUnlimited = benefitType === "unlimited";
  const isDiscountOnly = benefitType === "discount";
  const includedRaw = Number(membership.includedCredits ?? plan.includedCredits ?? membership.creditsTotal ?? plan.credits ?? 0);
  const remainingRaw = Number(membership.creditsRemaining ?? membership.remainingCredits ?? includedRaw);
  const usedRaw = Number(membership.creditsUsed ?? membership.usedCredits ?? NaN);

  if (isUnlimited || isDiscountOnly) {
    return {
      benefitType,
      isUnlimited,
      isDiscountOnly,
      isCreditBased: false,
      included: 0,
      remaining: 0,
      used: 0,
      usedPct: 0,
      remainingPct: 100,
    };
  }

  const included = Number.isFinite(includedRaw) ? Math.max(0, includedRaw) : 0;
  const remaining = Number.isFinite(remainingRaw) ? Math.max(0, Math.min(remainingRaw, included || remainingRaw)) : 0;
  const used = Number.isFinite(usedRaw) ? Math.max(0, usedRaw) : Math.max(0, included - remaining);
  const usedPct = included > 0 ? Math.max(0, Math.min(100, Math.round((used / included) * 100))) : 0;
  const remainingPct = included > 0 ? Math.max(0, Math.min(100, Math.round((remaining / included) * 100))) : 0;
  return { benefitType, isUnlimited, isDiscountOnly, isCreditBased: true, included, remaining, used, usedPct, remainingPct };
}
